import type { CommentChild } from '../../types/feedbacks';

export function reshapeChildren(items: CommentChild[], parent: CommentChild): CommentChild[] {
  let children: CommentChild[] = [];

  for (let i = 0; i < items.length; i++) {
    let child = items[i];
    if (child.parentId === parent.id) {
      child = items.splice(i, 1)[0];
      --i;
      children = reshapeChildren(items, child);
      if ('commentChildren' in parent) {
        parent.commentChildren.push(child);
      } else {
        Object.assign(parent, { commentChildren: [child] });
      }
    }
  }

  return children;
}

export function findAndReshape(feedbacks: CommentChild[]) {
  const feedbacksCopy = [...feedbacks];

  feedbacksCopy.sort((a, b) => {
    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
  });

  for (let i = 0; i < feedbacksCopy.length; i++) {
    reshapeChildren(feedbacksCopy, feedbacksCopy[i]);
  }

  return feedbacksCopy;
}
